define('../app/fukit/view/block/content.right.text.header.view',['require','exports','module','underscore','uikit/uikit','../../helpers/factory'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      UIKit   = require('uikit/uikit'),
      Factory = require('../../helpers/factory');

  var ContentRightTextHeaderView = UIKit.ItemView.extend({
    className: 'ui segment blue content actions header',

    template: function() {
      return '<div class="ui grid"><div class="column eight wide"><ui name="headerTextView" /></div> <div class="column eight wide right aligned"><ui name="rightTextView" /></div></div>';
    },

    options: {
      attached: false,
      color: 'blue',
      padded: false,
    },

    internalViewOptions: {
      headerTextView: Factory.extendOptionValueWithDefaults('header', {
        type: UIKit.Header,
        tagName: 'h4',
      }),
      rightTextView: Factory.extendOptionValueWithDefaults('rightText', {
        type: UIKit.Header,
        tagName: 'h4',
        muted: true,
      }),
    },

    updateAttributes: function() {
      var attached = this.getOption('attached');
      this.addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
      this.addClass(this.getOption('color'), this.getBoolOption('color')),
        this.addClass('padded', this.getBoolOption('padded'));
    },
  });

  module.exports = ContentRightTextHeaderView;
});

